import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ width, height, fill = "#000" }) => {
  return (
    <svg
      width={width || "10"}
      xmlns="http://www.w3.org/2000/svg"
      height={height || "10"}
      viewBox="0 0 96 96"
      fill={fill}
    >
      <path d="m95.118,21.399l-8.517-8.517c-1.179-1.179-3.078-1.179-4.257,0l-43.545,45.972-24.96-24.972c-1.191-1.191-3.123-1.191-4.314,0l-8.628,8.634c-1.191,1.188-1.191,3.12 0,4.314l35.499,36.324c.687,.69 1.62,.927 2.517,.81 .927,.138 1.893-.096 2.604-.81l53.601-57.495c1.176-1.176 1.176-3.084 0-4.26z" />
    </svg>
  );
};

export default memo(Icon);
